import { render, staticRenderFns } from "./TeamTable.vue?vue&type=template&id=0b1b3672&scoped=true"
import script from "./TeamTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./TeamTable.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./TeamTable.vue?vue&type=style&index=0&id=0b1b3672&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1b3672",
  null
  
)

export default component.exports